import BulkManageDesktop from "common/components/BulkManageDesktop";
import type { LinkedInProfile } from "common/types";

import { MANAGE_BLACKLIST_ACTIONS } from "../../../constants";
import BulkRemoveFromBlacklist from "../BulkRemoveFromBlacklist";

import type { Company } from "../../../types";

interface DesktopManageBlacklistProps {
  selectedItems: (Company | LinkedInProfile)[];
  resetSelection: () => void;
  blacklistType: "accounts" | "companies";
}

export default function DesktopManageBlacklist({
  selectedItems,
  resetSelection,
  blacklistType,
}: DesktopManageBlacklistProps) {
  return (
    <BulkManageDesktop
      actions={MANAGE_BLACKLIST_ACTIONS}
      selection={selectedItems}
      clearSelection={resetSelection}
      renderActionComponent={({ onClose }) => (
        <BulkRemoveFromBlacklist
          selectedItems={selectedItems}
          onBack={onClose}
          onSuccess={() => {
            onClose();
            resetSelection();
          }}
          blacklistType={blacklistType}
        />
      )}
    />
  );
}
